import { Stack, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  label: string;
  value: string | null | undefined;
  to?: string;
  indicator?: ReactNode;
};

export const Field = ({ label, value, to, indicator }: Props) => (
  <Stack spacing="0.5">
    <Text fontSize="xs" color="gray.500" textTransform="uppercase" letterSpacing="wide">
      {label}
    </Text>

    <Show if={!value}>
      <Text fontSize="sm" color="gray.400" fontStyle="italic">
        Not matched
      </Text>
    </Show>

    <Stack direction="row" align="center" spacing="1.5">
      <Show if={!!value && !!to}>
        <Link to={to ?? ''}>
          <Text fontSize="sm" fontWeight="bold" textDecoration="underline">
            {value}
          </Text>
        </Link>
      </Show>

      <Show if={!!value && !to}>
        <Text fontSize="sm" fontWeight="medium">
          {value}
        </Text>
      </Show>

      <Show if={!!value && !!indicator}>{indicator}</Show>
    </Stack>
  </Stack>
);
